/**
 * Classic S, intermission 3: a race against the magic wall (docs/spec/03 §2). Two tiers of
 * boulders over the wall; the first to land starts its timer, so think before you dig.
 */

import type { CaveDef } from '../types';

export const caveS: CaveDef = {
  id: 'S',
  name: 'QUICKSILVER',
  hint: 'The wall wakes at the first stone. Be ready for it.',
  intermission: true,
  colors: [5, 14, 1],
  diamondValue: 35,
  extraValue: 50,
  magicWallTime: 6,
  fill: { base: '.', items: [['r', 15], ['d', 10]] },
  levels: [
    { seed: 3001, diamonds: 8, time: 30, tick: 150 },
    { seed: 3002, diamonds: 10, time: 28, tick: 140 },
    { seed: 3003, diamonds: 11, time: 26, tick: 130 },
    { seed: 3004, diamonds: 12, time: 24, tick: 120 },
    { seed: 3005, diamonds: 14, time: 22, tick: 110 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWW',
    'WP.??????????????.XW',
    'W..??????????????..W',
    'W..??????????????..W',
    'W.?r?r?r?r?r?r?r?r.W',
    'W..................W',
    'W.?r?r?r?r?r?r?r?r.W',
    'W..................W',
    'W.mmmmmmmmmmmmmmmm.W',
    'W                  W',
    'W                  W',
    'WWWWWWWWWWWWWWWWWWWW',
  ],
};
